module.exports = __webpack_public_path__ + "img/Ferimentos e aberturas naturais macieira- Poda.9e65a1e4.webp";